module.exports = __webpack_public_path__ + "img/AURE_S.b563be6d.jpg";